import React, { useState } from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { SVGIcon as Icon } from 'common/components';
import { ModalCalendar } from '../ModalCalendar';
import { formatOpeningHoursForDate } from 'utils/helpers/openingHours';
import './operation-hours.less';

const OperationHours = ({ openingHours, featuredFlags, furtherDays }) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const [date, setDate] = useState(
    DateTime.local().plus({ days: furtherDays })
  );
  const className = useClassName('OperationHours');

  const updateSelectedDate = (calendarSelectedDate) => {
    setDate(DateTime.fromJSDate(calendarSelectedDate));
    setOpenCalendar(false);
  };

  const closeModal = () => setOpenCalendar(false);

  const renderControls = () => {
    const today = DateTime.local();
    return (
      <div className={className('operation-hours-controls')}>
        <p onClick={() => setOpenCalendar(true)}>
          {today.toFormat('yyyy-MM-dd') === date.toFormat('yyyy-MM-dd')
            ? 'Today'
            : date.toFormat('LLL dd')}
          <Icon size="mini" name="angle-down" className="chevron" />
        </p>
        <ModalCalendar
          selectedDate={date.toISO()}
          open={openCalendar}
          updateSelectedDate={updateSelectedDate}
          closeModal={closeModal}
        />
      </div>
    );
  };

  const getLabel = () => {
    const comingSoon = featuredFlags.includes('Coming Soon');

    if (comingSoon) return 'Coming Soon';

    return formatOpeningHoursForDate(openingHours, date);
  };

  const renderOperationHours = () => {
    return (
      <div className={className('operation-hours')}>
        <p>{getLabel()}</p>
      </div>
    );
  };

  const renderHours = () => {
    return (
      <div className={className('operation-hours-container')}>
        {renderOperationHours()}
        {renderControls()}
      </div>
    );
  };

  return <div className={className('container')}>{renderHours()}</div>;
};

OperationHours.propTypes = {
  openingHours: PropTypes.object,
  featuredFlags: PropTypes.arrayOf(PropTypes.string),
  furtherDays: PropTypes.number,
};

OperationHours.defaultProps = {
  featuredFlags: [],
  furtherDays: 0,
};

export default OperationHours;
